import 'react-app-polyfill/stable';
import 'resize-observer-polyfill/dist/ResizeObserver.global';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import { AppRegistry } from 'react-native';

import { App } from '@hmerp/components/src/App';

import '../public/index.css';

AppRegistry.registerComponent('hmerp', () => App);
AppRegistry.runApplication('hmerp', {
  rootTag: document.getElementById('root'),
});
